import {
// @ts-expect-error - react-dnd@3 has no types
DragSource } from 'react-dnd';
import { memo } from 'react';
import { reorderingItemType } from '../../constants';
import { useReorderingContext } from '../../core/ReorderingContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const withItemDrag = Wrapped => {
  const dragSpec = {
    beginDrag: props => {
      props.reordering.startDragging({
        fromIndex: props.columnIndex,
        itemSize: props.originalWidth
      });
      return {
        index: props.columnIndex
      };
    },
    endDrag: props => {
      props.reordering.endDragging();
    }
  };
  const collectDrag = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  });
  const Dragged = DragSource(reorderingItemType, dragSpec, collectDrag)(Wrapped);
  return /*#__PURE__*/memo(props => {
    const reordering = useReorderingContext();
    return /*#__PURE__*/_jsx(Dragged, Object.assign({}, props, {
      reordering: reordering
    }));
  });
};